import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, makeStyles, Text, Card, CardHeader } from "@fluentui/react-components";
import { ArrowRight16Regular } from "@fluentui/react-icons";
import { getEntityIcon } from "../utils/Helpers";
import Icon from "../blocks/Icon";
import Container from "../blocks/Container";
import { themeTokens } from "../utils/Theming";
import _ from "lodash";
import { ENTITY_RELATION_CONTACT } from "../utils/Constants";

const useStyles = makeStyles({
  heading: {
    marginTop: 0,
  },
  card: {
    marginBottom: themeTokens.spacingVerticalMNudge,
  },
});

const EntitySelectionPage = ({entities}) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (entities.length === 1) {
      const entity = entities[0];
      const isRelationContact = entity.name === ENTITY_RELATION_CONTACT;
      navigate(`/${entity.name.toLowerCase()}/${entity.uid}`, 
        { state: 
          { 
            skipPageHeader: isRelationContact ? false : true, 
            isEntitySelection: false 
          } 
        }
      );
    }
    setInitialized(true);
  }, [entities]);

  const handleEntitySelection = (entity) => {
    navigate(`/${entity.name.toLowerCase()}/${entity.uid}`, 
      { state: 
        { 
          skipPageHeader: false, 
          isEntitySelection: true 
        } 
      }
    );
  };

  if (!initialized) {
    return null;
  }

  return (
    <Container>
      <div>
          <Text as="h2" size={400} weight="bold" block className={styles.heading}>
            Who is this?
          </Text>
          <Text as="p" block>
            We recognize this email as these options:
          </Text>

          {entities.map((entity) => {
            const IconComponent = getEntityIcon(entity.name, 20);

            return (
              <Card orientation="horizontal" className={styles.card} key={entity.uid}>
                <CardHeader
                  image={<Icon icon={<IconComponent />} size="medium" />}
                  header={<Text>{_.startCase(entity.name)}</Text>}
                  action={
                    <Button
                      icon={<ArrowRight16Regular />}
                      onClick={() => handleEntitySelection(entity)}
                    />
                  }
                />
              </Card>
            );
          })}
        </div>
    </Container>
  );
};

export default EntitySelectionPage;
